import React from "react";
import { Button } from '../PSY/Button'
import { useNavigate } from "react-router-dom";

export const NoTrove: React.FC = props => {
  const navigate = useNavigate();

  return (
    <div className="bg-component border-component py-16 flex flex-col items-center h-full">
      <div className="text-style-value mt-6">You haven't borrowed any SLSD yet.</div>
      <div className="text-style-desc mt-3 mb-6 px-16 text-center">You can borrow SLSD against collateral by opening a Borrow Position.</div>
      <Button onSubmit={() => {
        navigate('products')
      }}>Borrow</Button>
    </div>
  );
};
